import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  createSelector,
} from '@reduxjs/toolkit';
import axios from 'axios';
import { FETCH_EVENT_URL } from '../appenv';

export const eventSelector = (state) => state.event;

export const fetchEvent = createAsyncThunk(
  'event/fetch',
  async () => {
    try {
      const response = await axios.get(FETCH_EVENT_URL);
      return response.data.data;
    } catch (error) {
      console.error(error);
    }
    return {};
  },
);

const eventAdapter = createEntityAdapter();

const {
  selectAll: selectAllEvent,
} = eventAdapter.getSelectors((state) => state.event);

export const selectEvent = () => createSelector(selectAllEvent, (events) => events[0]);

export const eventSlice = createSlice({
  name: 'event',
  initialState: eventAdapter.getInitialState(),
  reducers: {},
  extraReducers: {
    [fetchEvent.fulfilled]: (state, action) => {
      eventAdapter.upsertMany(state, action.payload);
    },
  },
});

export default eventSlice.reducer;
